import { ClipboardTextIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import type { SendPaperworkFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

export function SendPaperworkNode({ data, selected }: NodeProps<SendPaperworkFlowNode>) {
  return (
    <NodeShell
      icon={ClipboardTextIcon}
      accent="blue"
      kind="Send paperwork"
      label={data.label}
      description={data.packetName ?? (data.paperworkTemplateId ? `Packet chosen` : `No packet chosen`)}
      selected={selected}
    />
  )
}
